// Client-side search that ignores case, accents, punctuation and spacing, so
// "tiesto" finds "Tiësto" and "1,2,3" finds "1, 2, 3".

// Letters with no Unicode decomposition, so NFD alone would not fold them.
const LETTER_FOLDS = {
  ß: 'ss', æ: 'ae', œ: 'oe', þ: 'th', ø: 'o', đ: 'd', ð: 'd', ł: 'l', ħ: 'h', ı: 'i', ŧ: 't',
};
const LETTER_FOLD_PATTERN = new RegExp(`[${Object.keys(LETTER_FOLDS).join('')}]`, 'g');

export function foldSearchText(text) {
  return String(text ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[^\p{L}\p{N}]/gu, '')
    .replace(LETTER_FOLD_PATTERN, (ch) => LETTER_FOLDS[ch]);
}

export function searchWords(query) {
  return String(query ?? '').split(/\s+/).map(foldSearchText).filter(Boolean);
}

// Fields are folded separately and joined with a space (which folded words
// never contain) so a word cannot match across two fields.
export function buildSearchHaystack(fields) {
  return fields.map(foldSearchText).filter(Boolean).join(' ');
}

export function matchesSearchWords(haystack, words) {
  return words.every((word) => haystack.includes(word));
}
